import {TypedUseSelectorHook, useSelector as useOriginalSelector} from 'react-redux'

import {State} from '../reducers'

const useSelector: TypedUseSelectorHook<State> = useOriginalSelector

// Use throughout the app instead of plain `useSelector`
export default useSelector
